<template>
  <header class="main-header cursor-pointer flex justify-between items-center" >
    <h1 class="logo"><strong><a @click.prevent="$router.push('/')" class="text-gray-700 no-underline" href="/"><span class="color-logo-1">best</span> <span class="color-logo-2">spots</span></a></strong></h1>

    <button class="bg-blue-400 hover:bg-blue-600 text-white font-bold py-1 px-2 rounded" @click.prevent="$router.push('/create')" href="#">Create</button>     
      
  </header>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  mounted () {
    this.getLists()
  },

  data () {
    return {
      menuOpen: false,
      openHelp: false,
    }
  },
  computed: {
    ...mapGetters([
      'lists'
    ])
  },
  methods: {
    ...mapActions([
      'getLists'
    ])
  }
}
</script>

<style>
.color-logo-1{
  color:#EA8472!important;
}
.color-logo-2{
  color:#B9E3EC!important;
}
</style>
<style scoped>
.main-header {
  padding:10px 24px;
  border-bottom: solid 1px #ddd;
  background: #233851;
}
.main-header .logo a {
  opacity: 1;
}
.main-header:hover .logo a {
  opacity: 0.9;
}
.menu-open {
  height:100vh;
}
.logo {
  font-size:16px;
}

.fade-enter-active {
  transition: opacity .3s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

 </style>



// WEBPACK FOOTER //
// SiteHeader.vue?269ca105